import { getSubdomain } from 'helpers/global';
import { useSelector } from 'react-redux';

function useAuthSelfServeAccess() {
  const subdomain = getSubdomain();
  const { isWhiteLabelCompany, isLoadingWhiteLabel } = useSelector((state) => state.whiteLabel);

  const canAccessSelfServeAuthRoutes =
    !subdomain || (!isLoadingWhiteLabel && !isWhiteLabelCompany);

  return {
    subdomain,
    canAccessSelfServeAuthRoutes
  };
}

export default useAuthSelfServeAccess;
